'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var trim = function trim(str) {
  return str.replace(/^\s+|\s+$/g, '');
};

exports.default = trim;


//////////////////
// WEBPACK FOOTER
// ./~/react-select/lib/utils/trim.js
// module id = 3703
// module chunks = 0